import axios, { AxiosResponse } from 'axios';

import { PoolMaintenance } from '../../components/admin-portal/Tables/Pools/PoolMaintenance/types';

import { POOLS } from '../endpoints';

export const getPools = () =>
  axios.get<PoolMaintenance[], AxiosResponse<PoolMaintenance[]>>(POOLS);

export const getPoolById = (rowId?: number | null) =>
  axios.get<PoolMaintenance, AxiosResponse<PoolMaintenance>>(
    `${POOLS}/${rowId}`
  );

export const editPoolMaintenance = (data: PoolMaintenance) =>
  axios.put(`${POOLS}/${data.id}`, data);

export const createPoolMaintenance = (data: PoolMaintenance) =>
  axios.post(POOLS, data);

export const deletePool = (id: number) => axios.delete(`${POOLS}/${id}`);
